<template>
  <div>
    <md-field>
      <md-skeleton avatar title :loading="load" :row="3" class="skeleton-item">
        <md-field-item
          title="目的地"
          arrow="arrow-right"
          :addon="pickerValue3"
          @click="isPickerShow0 = true"
        >
        </md-field-item>

        <md-field-item
          title="收貨倉庫"
          arrow="arrow-right"
          :addon="warehouseName"
          @click="wareHousePickerShow = true"
        >
        </md-field-item>
        <md-field-item
          title="線路"
          arrow="arrow-right"
          :addon="pickerValue2"
          @click="isPickerShow1 = true"
        >
        </md-field-item>
        <md-input-item
          title="重量/體積"
          type="money"
          v-model="weight"
          @blur="getWeight"
          align="right"
          placeholder="請輸入重量/體積"
        >
          <div class="input-operator" slot="right">KG/CBM</div>
        </md-input-item
        >
        <md-button
          :type="weight ? 'primary' : 'disabled'"
          @click="createPay"
          style="margin-top: 1rem"
        >
          <md-activity-indicator
            v-if="loading"
            class="md-activity-indicator-css"
            type="carousel"
            :size="15"
            color="#fff"
            text-color="#fff"
          ></md-activity-indicator>
          <span v-else>試算</span>
        </md-button>
      </md-skeleton>
    </md-field>

    <div style="width: 96%;margin-left: 2%" v-if="showContainer">
      <div
        style="display: flex;align-items: center;height: 0.8rem;font-size: 0.34rem"
      >
        <span>試算結果</span>
      </div>
      <div class="menu" v-if="triResult.price > 0">
        <div style="text-align: left;height: 1rem;">
          <span style="font-size: 0.3rem;margin-left: 0.2rem;font-weight: 500">{{ warehouseName }}</span>
        </div>

        <div
          style="display: flex;align-items: center;padding-top:0.2rem;font-size: 0.3rem;margin-left: 0.2rem"
        >
          <span>{{ triResult.toCountryName }}</span>
          <span style="margin-left: 0.2rem">{{
              triResult.transCode
            }}</span>
          <span style="margin-left: 0.2rem">{{ triResult.weight }}KG</span>
        </div>
        <div
          style="display: flex;align-items: center;margin-top:0.2rem;font-size: 0.3rem;margin-left: 0.2rem"
        >
          <span>說明：</span>
          <span style="margin-left: 0.2rem">{{ triResult.memo }}</span>
        </div>
        <div
          style="display: flex;align-items: center;margin-top:0.2rem;margin-bottom:0.05rem;font-size: 0.3rem;margin-left:0.2rem"
        >
          <span>預計價格：</span>
          <span style="margin-left: 0.2rem;font-size: 0.5rem;color: #F97004"
          >{{ triResult.price }}元</span
          >
          <span>起</span>
        </div>
        <div
          style="display: flex;align-items: center;padding-bottom:0.1rem;font-size: 0.3rem;margin-left: 0.2rem"
        >

        </div>
      </div>
      <div
        style="display: flex;justify-content:center;align-items: center;height: 1rem;font-size: 0.32rem;margin-left:
      0.2rem;"
        v-else
      >
        <span style="color: orangered">重量不在價格區間內</span>
      </div>
      <div
        style=";display:flex;flex-direction: column; padding-bottom:0.1rem;line-height: 0.4rem; font-size: 0.25rem;margin-left: 0.2rem;text-align:left">
        <span>
        1、如体积较大则按体积重计费；</span>
        <span>2、此价格为RMB价格，不包含增值服务与保价等费用；</span>
        <span>3、货重以实际入库重量为准，此处显示的仅为参考价格</span>
      </div>
    </div>
    <md-selector
      v-model="isPickerShow0"
      :data="pickerData0"
      title="請選擇目的地"
      large-radius
      class="cheklist"
      min-height="100px"
      :default-value="pickerValue0"
      @choose="onPicker"
      :is-check="true"
    ></md-selector>
    <md-selector
      v-model="isPickerShow1"
      :data="pickerData1"
      :default-value="pickerValue1"
      title="請選擇線路"
      large-radius
      min-height="100px"
      class="cheklist"
      :is-check="true"
      @choose="onPickerConfirm"
    ></md-selector>
    <md-selector
      v-model="wareHousePickerShow"
      :data="wareHouseList"
      :default-value="warehouse"
      title="請選擇收貨倉庫"
      large-radius
      min-height="100px"
      class="cheklist"
      :is-check="true"
      @choose="onPickerWareHouse"
    ></md-selector>
  </div>
</template>

<script>
import {
  Selector,
  Field,
  FieldItem,
  Toast,
  InputItem,
  ActivityIndicator,
  Button,
  Skeleton
} from "mand-mobile";
import {isBlank} from "@/until/common.js"

export default {
  name: "try",
  components: {
    [Skeleton.name]: Skeleton,
    [Selector.name]: Selector,
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [FieldItem.name]: FieldItem,
    [ActivityIndicator.name]: ActivityIndicator,
    [Button.name]: Button
  },
  data() {
    return {
      weight: null,
      loading: false,
      load: true,
      isPickerShow0: false,
      isPickerShow1: false,
      pickerValue0: "",
      pickerValue1: "",
      pickerValue2: "请选择",
      counid: '',
      pickerValue3: "",
      pickerData0: [],
      pickerData1: [],
      triResult: {},
      showContainer: false,
      // 仓库列表
      wareHouseList: [],
      warehouse: "",
      warehouseName: "请选择",
      wareHousePickerShow: false
    };
  },
  mounted() {
    this.pickerValue0 = this.$route.query.id;
    this.counid = this.$route.query.id;
    //
    this.getWareHouseList(this.$route.query.id);
  },
  methods: {
    listByCountry(id, warehouseId) {
      const par = {
        countryId: id,
        warehouseId: warehouseId
      };
      this.pickerValue2 = '请选择';
      this.pickerValue1 = '';
      this.weight = null;
      this.showContainer = false;
      this.http.APIASK(this.ports.getShopServiceByWarehouseId, "get", par).then(res => {
        const data = res.map(function (item) {
          return {
            text: item.transCode,
            value: item.id
          };
        });
        this.pickerData1 = data;
        // data.length>0? this.pickerValue2 = data[0].text:'';
        // data.length>0?this.pickerValue1 = data[0].value:'';
        // if(this.weight&&this.pickerValue2 ){
        //   this.createPay()
        // }else{
        //   this.triResult.price=0
        // }

      });
    },
    getWareHouseList(id) {
      this.wareHouseList = [];
      this.warehouse = '';
      this.warehouseName = '请选择';
      this.weight = null;
      this.showContainer = false;
      const par = {
        countryId: id
      };
      this.http.APIASK(this.ports.getShopWarehouseByCountryId, "get", par).then(res => {
        const data = res.map(function (item) {
          return {
            text: item.name,
            value: item.id
          };
        });
        const fitItem = JSON.parse(this.$route.query.list).find(val => {
          return val.value == this.pickerValue0;
        });
        this.pickerValue3 = fitItem.text;
        this.pickerData0 = JSON.parse(this.$route.query.list);
        // this.warehouse = data[0].value
        // this.warehouseName = data[0].text
        this.wareHouseList = data;
        this.load = false;
        this.listByCountry(id, this.warehouse);

      });
    },
    onPicker({value, text}) {
      if (this.pickerValue0 != value) {
        // this.listByCountry(value);
        console.log('counid', value)
        this.counid = value
        this.getWareHouseList(value)
        this.pickerValue0 = value;
        this.pickerValue3 = text;
      }
    },
    onPickerConfirm({value, text}) {
      if (this.pickerValue1 != value) {
        this.pickerValue1 = value;
        this.pickerValue2 = text;
        this.weight = null;
        this.showContainer = false;
        // if(this.weight){
        //   this.createPay()
        // }
      }
    },
    onPickerWareHouse({value, text}) {
      this.warehouse = value
      this.listByCountry(this.counid, this.warehouse);
      this.warehouseName = text
    },
    getWeight(name) {
      this.showContainer = false;
    },
    createPay() {
      if (!this.warehouse) {
        Toast.failed("请选择仓库");
        return
      }
      if (!this.pickerValue1) {
        Toast.failed("请选择线路");
        return
      }

      this.loading = true;
      const par = {
        id: this.pickerValue1,
        weight: this.weight,
        warehouse: this.warehouse,
        shopCode: JSON.parse(localStorage.getItem("shopkey")).appCode
      };
      this.http
        .APIASK(this.ports.countPrice, "get", par)
        .then(res => {
          this.triResult = res;
          this.triResult.weight = this.weight;
          this.loading = false;
          this.showContainer = true;
        })
        .catch(err => {
          this.loading = false;
        });
    },
  }
};
</script>

<style lang="less">
.md-field-item.is-solid .md-field-item-title {
  width: auto;
}

.menu {
  background-color: white;
  border-radius: 0.18rem;
  margin-bottom: 0.2rem;
  box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
}
</style>
